import { TriggeredMessagesResult } from 'modules/campaignsSentMessagesLogs/types';
import styled from 'styled-components';
import { colors } from 'ui/theme';
import { TableLink } from './Styled';

const StyleText = styled.p`
color: ${colors.textSecondary};
`;

const CAMPAIGN_DETAILS_URL = '/analytics/campaignPerformance?campaignId=';

export const CampaignColumn = ({ row }: { row: TriggeredMessagesResult }) => (
  <>
    <TableLink href={`${CAMPAIGN_DETAILS_URL}${row.campaignId}`}>{row.campaignName}</TableLink>
    <StyleText>{`ID: ${row.campaignId}`}</StyleText>
  </>
);
